<app-loader [show]="loading"></app-loader>
<router-outlet></router-outlet>
